module.exports = __webpack_public_path__ + "img/doorpostscene1.59d3b42d.png";